export var HIDE_DROPDOWN_MENU = "hideDropdownMenu";
export var SET_DROPDOWN_MENU = "setDropdownMenu";
export var SET_TRIGGER_BUTTON = "setTriggerButton";
export var SHOW_DROPDOWN_MENU = "showDropdownMenu";
export var SET_DROPDOWN_MENU_POSITION = "SetDropdownMenuPosition";
export var showDropdownMenu = function showDropdownMenu() {
  return {
    type: SHOW_DROPDOWN_MENU
  };
};
export var hideDropdownMenu = function hideDropdownMenu() {
  return {
    type: HIDE_DROPDOWN_MENU
  };
};
/**
 * Action that save dropdownMenu info.
 * @param {Object} dropdownMenu properties from current useRef()
 * @returns {Object}
 */
export var setDropdownMenu = function setDropdownMenu(dropdownMenu) {
  return {
    type: SET_DROPDOWN_MENU,
    payload: {
      dropdownMenu: dropdownMenu
    }
  };
};
export var setDropdownMenuPosition = function setDropdownMenuPosition(position) {
  return {
    type: SET_DROPDOWN_MENU_POSITION,
    payload: {
      position: position
    }
  };
};
/**
 * Action that save triggerButton info.
 * @param {Object} triggerButton properties from current useRef()
 * @returns {Object}
 */
export var setTriggerButton = function setTriggerButton(triggerButton) {
  return {
    type: SET_TRIGGER_BUTTON,
    payload: {
      triggerButton: triggerButton
    }
  };
};